module.exports = __webpack_public_path__ + "./docs/img/csharp.6a36cb101738a76eb95801df03c7e296.svg";